<template>
  <div class="box">
    <navBar :tabIndex="99" :showLogo="true"></navBar>
    <div class="venue-topbg"></div>
    <div class="topItem">
      <div class="topShit">
        <div style="color: #8a8a8a; cursor: pointer" @click="toMain">首页</div>
        <img class="topR" src="@/assets/right-icon.png" alt="" />
        <div
          style="color: #3f639a"
          :style="{
            'font-size': $px2rem(`${14}px`),
          }"
        >
          公众纪念馆
        </div>
      </div>
    </div>
    <div>
      <div class="moIt">
        <loading-gif v-if="loading" title="正在努力加载中..."></loading-gif>
        <div v-else>
          <div>
            <div v-if="outList.length">
              <div
                class="moItem"
                v-for="(item, index) in outList"
                :key="index"
                @click.stop="toWorship(item)"
              >
                <div style="position: relative; margin-right: 28px">
                  <img
                    :src="item.picture ? item.picture : item.spiritTabletUrl"
                    class="moImg"
                    alt=""
                    srcset=""
                    :style="{
                      'object-fit': item.picture ? 'cover' : 'contain',
                      border: item.spiritTabletUrl
                        ? '1px solid #EAAC49'
                        : 'none',
                    }"
                  />
                </div>
                <div style="display: flex; flex-direction: column; width: 100%">
                  <div
                    style="
                      color: #5a2a00;
                      font-weight: 600;
                      text-align: left;
                      display: flex;
                      align-items: center;
                    "
                    :style="{
                      'font-size': $px2rem(`${20}px`),
                      'margin-bottom': $px2rem(`${17}px`),
                    }"
                  >
                    {{ item.name }}纪念{{ item.isStele == 1 ? "碑" : "馆" }}
                    <div
                      class="followBtn"
                      @click.stop="toFollow(item)"
                      :style="{
                        'font-weight': item.actionStat.isFocus ? '400' : '600',
                        background: item.actionStat.isFocus
                          ? '#FCF3E5'
                          : '#EAAC49',
                        border: item.actionStat.isFocus
                          ? '1px solid #EAAC49'
                          : 'none',
                      }"
                    >
                      {{ item.actionStat.isFocus ? "已关注" : "+关注" }}
                    </div>
                  </div>
                  <div class="remarks">
                    {{ item.introduction || "暂无简介" }}
                  </div>
                  <div class="moFlex">
                    <div class="moF-it">
                      <span
                        style="color: #a66b25"
                        :style="{
                          'font-size': $px2rem(`${14}px`),
                          'margin-right': $px2rem(`${22}px`),
                        }"
                        >建馆时间:</span
                      >
                      <span
                        style="color: #714209"
                        :style="{
                          'font-size': $px2rem(`${14}px`),
                        }"
                        >{{ item.createTime.split(" ")[0] }}</span
                      >
                    </div>
                    <div class="moF-it">
                      <span
                        style="color: #a66b25"
                        :style="{
                          'font-size': $px2rem(`${14}px`),
                          'margin-right': $px2rem(`${22}px`),
                        }"
                        >留言数量:</span
                      >
                      <span
                        style="color: #714209"
                        :style="{
                          'font-size': $px2rem(`${14}px`),
                        }"
                        >{{ item.messageCount }}</span
                      >
                    </div>
                    <div class="moF-it">
                      <span
                        style="color: #a66b25"
                        :style="{
                          'font-size': $px2rem(`${14}px`),
                          'margin-right': $px2rem(`${22}px`),
                        }"
                        >香火值:</span
                      >
                      <span
                        style="color: #714209"
                        :style="{
                          'font-size': $px2rem(`${14}px`),
                        }"
                        >{{ item.actionStat.totalSpecialCount }}</span
                      >
                    </div>
                    <div class="moF-it">
                      <span
                        style="color: #a66b25"
                        :style="{
                          'font-size': $px2rem(`${14}px`),
                          'margin-right': $px2rem(`${22}px`),
                        }"
                        >供品数量:</span
                      >
                      <span
                        style="color: #714209"
                        :style="{
                          'font-size': $px2rem(`${14}px`),
                        }"
                        >{{ item.giftCount }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <none-data></none-data>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="outList.length"
        :style="{
          'padding-top': $px2rem(`${43}px`),
          'padding-bottom': $px2rem(`${76}px`),
        }"
      >
        <el-pagination
          background
          layout="prev, pager, next,jumper"
          :total="total"
          @current-change="curChange"
          :current-page="pageNo"
          :page-size="pageSize"
        >
        </el-pagination>
      </div>
    </div>
    <tabBar></tabBar>
  </div>
</template>

<script>
import { getHallHuman, actionAll } from "@/api/request";
import NoneData from "@/pages/components/none-data.vue";
import LoadingGif from "@/pages/components/loadingGif.vue";
export default {
  components: { NoneData, LoadingGif },
  data() {
    return {
      outList: [],
      loading: false,
      total: 0,
      pageNo: 1,
      pageSize: 10,
    };
  },
  created() {
    this.getOutList();
  },
  mounted() {},
  methods: {
    getOutList() {
      this.loading = true;
      let data = {
        type: 4,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      };
      getHallHuman(data).then((res) => {
        this.loading = false;
        this.total = Number(res.data.result.total);
        this.outList = res.data.result.records;
      });
    },
    toMain() {
      this.$router.push({ path: "/" });
    },
    curChange(e) {
      this.pageNo = e;
      this.getOutList();
    },
    toWorship(e) {
      console.log(e);
      this.$router.push({ path: "/worship", query: { id: e.id } });
    },
    toFollow(e) {
      if (!localStorage.getItem("token")) {
        this.$router.push("login");
        return;
      }
      let data = {
        bizType: 16,
        itemId: e.id,
        key: "FOCUS",
      };
      actionAll(data).then((res) => {
        e.actionStat.isFocus = !e.actionStat.isFocus;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.box {
  background: #f4f5f7;
  :deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #579487;
    color: #fff;
  }
  .venue-topbg {
    width: 100%;
    height: 100px;
    background: url("../../assets/venue1.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center;
    margin-bottom: 13px;
  }
  .topItem {
    font-size: 14px;
    z-index: 2;
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 30px;
    .topShit {
      display: flex;
      align-items: center;
    }
    .topR {
      width: 4.8px;
      height: 9px;
      flex: none;
      margin: 0 16px;
    }
  }
  .moIt {
    width: 1200px;
    min-height: 770px;
    margin: 0 auto;
    z-index: 2;
    position: relative;
    display: flex;
    flex-direction: column;
  }
  .add-hall {
    width: 150px;
    line-height: 46px;
    background: #e2a340;
    color: #7b3a00;
    font-size: 20px;
    font-weight: 600;
    border-radius: 9px;
    margin: 0 auto;
    cursor: pointer;
  }
  .moItem {
    height: 200px;
    background: url("https://mmwz.oss-cn-shenzhen.aliyuncs.com/statics/app/static/version/memo/moItem-bg.png")
      no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
    margin-bottom: 20px;
    padding: 26px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  .moItem:hover {
    filter: contrast(1.05);
  }
  .moImg {
    width: 150px;
    height: 150px;
    border-radius: 10px;
  }
  .remarks {
    color: #a66b25;
    font-size: 14px;
    text-align: left;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    overflow: hidden;
    margin-bottom: 10px;
    min-height: 55px;
  }
  .moFlex {
    display: flex;
    justify-content: space-between;
  }
  .moF-it {
    line-height: 25px;
    width: 50%;
    text-align: left;
  }
  .followBtn {
    width: 116px;
    height: 38px;
    line-height: 38px;
    color: #7b3a00;
    font-size: 20px;
    text-align: center;
    border-radius: 40px;
    margin-left: 24px;
  }
}
</style>
